export default {
    LEFTMENU_SETAKTIF: 'LEFTMENU_SETAKTIF',
    LEFTMENU_SETSUBAKTIF: 'LEFTMENU_SETSUBAKTIF'
}